import { render, staticRenderFns } from "./tradeNews.vue?vue&type=template&id=639e5dca&scoped=true"
import script from "./tradeNews.vue?vue&type=script&lang=js"
export * from "./tradeNews.vue?vue&type=script&lang=js"
import style0 from "./tradeNews.vue?vue&type=style&index=0&id=639e5dca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639e5dca",
  null
  
)

export default component.exports